import { Typography } from '@mui/material';

/** Bullet separator between segments in the upload card context bar. */
export function UploadCardContextSeparator() {
  return (
    <Typography variant="subtitle2" color="text.secondary">
      •
    </Typography>
  );
}
